<template>
    <div>
        <ul class="nav mb-2 d-block d-sm-flex"
            :class="[{
                'nav-pills': pills,
                'nav-fill': fill,
                'nav-tabs': !pills && !fill,
                'flex-sm-nowrap': !wrap
            }]">
            <li v-for="(tab, index) in tabs"
                :key="index"
                class="nav-item"
                :class="{'disabled pointer-events-none': tab.disabled }">
                <a :href="tab.href"
                   class="nav-link h-100"
                   :class="{ 'active': tab.isActive, 'p-1 px-2 text-xxs': small, 'text-muted': small && !tab.isActive }"
                   @click.prevent="selectTab(tab)"
                   role="button">
                    <font-awesome-icon v-if="tab.icon" :icon="tab.icon" class="me-1" /> {{ tab.name }}
                </a>
            </li>
        </ul>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'Tabs',
        props: {
            fill: {
                type: Boolean,
                default: false
            },
            pills: {
                type: Boolean,
                default: true
            },
            small: {
                type: Boolean,
                default: false
            },
            wrap: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                tabs: []
            }
        },
        created() {
            this.tabs = this.$children
        },
        methods: {
            selectTab(selectedTab) {
                this.tabs.forEach(tab => {
                    tab.isActive = (tab.name === selectedTab.name)
                })
                this.$emit('selectTab', selectedTab)
            }
        }
    }
</script>
